export const refs = {
    body: document.querySelector('body'),
    themeToggle: document.querySelector('#theme-toggle'),
    swiperWrapper: document.querySelector('.feedback-swiper-box.swiper-wrapper'),
    scrollTopBtn: document.querySelector('.scroll-top-btn'),
    // product-modal
    modalProduct: document.querySelector('.modal-product'),
    modalDetailsContent: document.querySelector('.modal-details-content'),
    // order-modal
    modalOrder: document.querySelector('.modal-order'),
    modalOrderSuccess: document.querySelector('.modal-order-successful'),
    modalOrderForm: document.querySelector('.modal-order-form'),
    // furniture
    categories: document.querySelector(".categories"),
    furnitureList: document.querySelector(".furniture-list"),
    loader: document.querySelector(".loader"),
    loadMoreBtn: document.querySelector(".show-more-btn"),
    allCategoriesBtn: document.querySelector(".all-category"),
    // navbar
    openMenuBtn: document.querySelector('.header-burger-menu'),
    closeMenuBtn: document.querySelector('.modal-close-btn'),
    mobileMenu: document.querySelector('.modal-navbar'),
    navLinks: document.querySelectorAll('.mobile-link, .mobile-buy-btn'),
    popularSwiperBox: document.querySelector('.popular-swiper-box.swiper-wrapper'),



}